import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ConnectionService } from './connection.service';
import { TransactionPreset } from '@contracts/interfaces/transaction-preset.interface';

interface PresetListResponse {
  presets: TransactionPreset[];
}

interface PresetResponse {
  preset: TransactionPreset;
}

@Injectable({
  providedIn: 'root'
})
export class TransactionPresetsService {

  constructor(private http: HttpClient, private connectionService: ConnectionService) {}

  list(): Observable<TransactionPreset[]> {
    return this.http.post<PresetListResponse>(`${this.connectionService.address}/transaction-preset-service/list`, {})
      .pipe(map(res => res.presets || []));
  }

  create(preset: TransactionPreset): Observable<TransactionPreset> {
    return this.http.post<PresetResponse>(`${this.connectionService.address}/transaction-preset-service/create`, { preset })
      .pipe(map(res => res.preset));
  }

  update(preset: TransactionPreset): Observable<TransactionPreset> {
    return this.http.post<PresetResponse>(`${this.connectionService.address}/transaction-preset-service/update`, { preset })
      .pipe(map(res => res.preset));
  }

  delete(id: string): Observable<boolean> {
    return this.http.post<{ deleted: boolean }>(`${this.connectionService.address}/transaction-preset-service/delete`, { id })
      .pipe(map(res => !!res.deleted));
  }
}
